import { Box } from "@mui/material";
import React, { useCallback } from "react";
import {
  Outlet,
  createBrowserRouter,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import "./App.css";

import Bookmarks from "./pages/Bookmarks";
import Home from "./pages/Home";
import Nav from "./components/Nav";
import SearchResultsPage from "./pages/SearchResultsPage";
import SingleProductPage from "./pages/SingleProductPage";
import useScrollRestoration from "./hooks/useScrollRestoration";

function readCategoryFromSearch(search) {
  return new URLSearchParams(search).get("key") || "";
}

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  // selectedCategory is derived from the URL synchronously on every render,
  // so a Back navigation lands with the correct category on the very first
  // commit (no useEffect-induced empty render in between).
  const selectedCategory = readCategoryFromSearch(location.search);

  const setSelectedCategory = useCallback(
    (category) => {
      navigate(category ? `/?key=${category}` : "/");
    },
    [navigate]
  );

  useScrollRestoration();

  return (
    <>
      <Box className="header">
        <Box
          sx={{
            maxWidth: "1440px",
            margin: "0 auto",
            padding: { xs: "0 16px", md: "0 60px" },
          }}>
          <Nav onSelectCategory={setSelectedCategory} />
        </Box>
      </Box>
      <Outlet context={{ selectedCategory, setSelectedCategory }} />
    </>
  );
}

function HomeRoute() {
  const ctx = useOutletContext();
  return (
    <Home
      selectedCategory={ctx?.selectedCategory || ""}
      setSelectedCategory={ctx?.setSelectedCategory || (() => {})}
    />
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <HomeRoute /> },
      { path: "search", element: <SearchResultsPage /> },
      { path: "products/:productId", element: <SingleProductPage /> },
      { path: "bookmarks", element: <Bookmarks /> },
    ],
  },
]);

export default router;
